<script>
import LoginModal from './LoginModal';

export default {
    components: { LoginModal },

    data() {
        return {
            modalOpen: false,
            showDropdown: false,
            showShareDropdown: false,
            menus: [{}],
            moreMenu: false,
            timer: false,
            showMenu: false,
            searchTerms: "",
            notification_count: 0,
        };
	},


    async mounted() {
        // Search works in a funky way. Search redirects to Home with a query string,
        // which forces remount of other components.
        // So if the search is set, but it in the input field.

        if (this.$route.query.search) {
            this.searchTerms = this.$route.query.search;
        }

        // Start loading profile data, as some data may be necessary for the navbar
        if (this.$store.getters.isAuthenticated) {
            this.$store.dispatch('loadProfileData');

            const notificationCount = await window.axios.get('/api/user/notifications_count');
            this.notification_count = notificationCount.data;
        }

        // Load menus for the More dropdown.
        const menus = await this.getMenus();
        this.menus = menus;
    },

    methods: {
        async logout() {
            try {
                await window.axios.post('/api/logout');
            } catch (error) {
                console.log(error.response);
            }

            this.$store.commit('logout');
        },

        async getMenus() {
            const menuData = await window.axios.get('/api/menus/');

            return menuData.data;
        },

        setSearch(searchTerms) {
            clearTimeout(this.timer);

            this.timer = setTimeout(async () => {
                this.$router.push('/?search=' + searchTerms);
            }, 2000);
        },

        activateSearch() {
            this.showDropdown = true;

            this.$nextTick(() => {
                this.$refs.search.focus();
            });
        },
    },
};
</script>

<template lang="pug" src='./template/Navbar.pug' />
<style lang="stylus" src='./styles/Navbar.styl' scoped />
